import React, { FunctionComponent } from 'react';
import { TOpenGraphMeta } from '@modules/layout/layout/components/AppLayout';
import { OpenAPIPageContent } from '@modules/utilities/pageBuild/content';
import { OpenAPIDocumentProvider } from '../context/DocumentProvider';
import { FilteredOperationsProvider } from '../context/FilteredOperationsProvider';
import OpenAPIAppContainer from './OpenAPIAppContainer';

type OpenAPIDocumentContainerProps = {
  content: OpenAPIPageContent;
  openGraphMeta: Partial<TOpenGraphMeta>;
};

const OpenAPIDocumentContainer: FunctionComponent<
  React.PropsWithChildren<OpenAPIDocumentContainerProps>
> = ({ content, openGraphMeta }) => {
  return (
    <OpenAPIDocumentProvider document={content.document}>
      <FilteredOperationsProvider content={content}>
        <OpenAPIAppContainer content={content} openGraphMeta={openGraphMeta} />
      </FilteredOperationsProvider>
    </OpenAPIDocumentProvider>
  );
};

export default OpenAPIDocumentContainer;
